/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_PROJECTS = (state) => {
    state.pending = true
}

/**
 * Set the retrieved project data
 *
 * @param  {Object} state
 * @param  {Object} data
 * @return {Void}
 */
const GET_PROJECTS_SUCCESS = (state, data) => {
    state.data = data.data
    state.meta = data.meta
    state.pending = false
    state.loaded = true
}

const GET_PROJECTS_FAILED = (state) => {
    state.data = []
    state.meta = {}
    state.pending = false
    state.loaded = false
}

/**
 * Reset the base project list data
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_PROJECT_LIST_DATA = (state) => {
    state.data = []
    state.meta = {}
    state.pending = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Replace the data for a project in the list state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const REPLACE_PROJECT_DATA = (state, payload) => {
    let project = state.data[payload.index]
    Object.keys(payload.project).forEach((key) => {
        project[key] = payload.project[key]
    })
}

/**
 * Update the layout state
 *
 * @param  {Object} state
 * @param  {Boolean} payload
 * @return {Void}
 */
const UPDATE_LAYOUT = (state, payload) => {
    state.cardLayout = payload
}

export default {
    RESET_STATE,
    GET_PROJECTS,
    UPDATE_LAYOUT,
    GET_PROJECTS_FAILED,
    GET_PROJECTS_SUCCESS,
    REPLACE_PROJECT_DATA,
    RESET_PROJECT_LIST_DATA
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/mutations.js